import React from 'react'
import { array, object, string } from 'prop-types'
import styled from '@emotion/styled'
import { withTheme } from 'emotion-theming'

// components
import ShowcaseCard from './ShowcaseCard'

// styled components
const OfferingsContainer = styled.div`
	${({ theme }) => theme.maxWidth.L};
	height: auto;
	margin: 2rem auto;
	text-align: center;
	width: 90%;
`

const Title = styled.h2`
	${({ theme }) => theme.header.h2};
	color: ${({ theme }) => theme.colors.navy};
	font-size: 35px;
	font-weight: 400;
	text-align: center;
`

const OfferingsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin: auto;
	width: 100%;

	${({ theme }) => theme.MQ.S} {
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
	}
`

const propTypes = {
	listOfferings: array.isRequired,
	sectionTitle: string.isRequired,
	theme: object.isRequired,
}

/**
 * This is the Offerings section on the Connect page
 * Should show cards for every offering we get from the backend
 */
function Offerings({ listOfferings, sectionTitle }) {
	return (
		<OfferingsContainer>
			<Title>{sectionTitle}</Title>
			<OfferingsWrapper>
				{listOfferings.map((offer, i) => {
					const { bulletPoints, description, imageUrl, title, url } = offer
					return (
						<ShowcaseCard
							bulletPoints={bulletPoints}
							description={description}
							image={imageUrl}
							key={i}
							title={title}
							url={url}
						/>
					)
				})}
			</OfferingsWrapper>
		</OfferingsContainer>
	)
}

Offerings.propTypes = propTypes

export default withTheme(Offerings)
